import { LocationVarKey } from "@swivl-mono/types";

import { IF_ALL, IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VoiceAfterHoursEmergencyCriteria,
  LocationVarKey.VoiceAfterHoursEmergencyVoiceMessage,
  LocationVarKey.VoiceAfterHoursEmergencyHasForward,
  LocationVarKey.VoiceAfterHoursEmergencyForwardPhoneNumber,
  LocationVarKey.VoiceAfterHoursEmergencyHasSMS,
  LocationVarKey.VoiceAfterHoursEmergencySMSPhoneNumbers,
  LocationVarKey.VoiceAfterHoursEmergencyHasEmail,
  LocationVarKey.VoiceAfterHoursEmergencyEmails,
  LocationVarKey.VoiceAfterHoursEmergencyAlertContent
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>After Hours Emergency</PageHeader>
      <div className="cortexDescription">
        Alerts will be sent outside of the Call Center Hours listed in{" "}
        <a href="/properties/page/details/hours" target="_blank" rel="noopener noreferrer" style={{ color: "#FF5B02", textDecoration: "underline" }}>
          Details
        </a>
        . List reasons for emergency notifications within the 'Emergency Criteria' text box.
      </div>
      <TextAreaRow {...page} marginTop label=" Emergency Criteria" keyName={LocationVarKey.VoiceAfterHoursEmergencyCriteria} />

      <TextAreaRow {...page} marginTop label=" Voice Message" keyName={LocationVarKey.VoiceAfterHoursEmergencyVoiceMessage} />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceAfterHoursEmergencyHasForward} label="Escalate" />
      <InputRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceAfterHoursEmergencyHasForward, "1")}
        keyName={LocationVarKey.VoiceAfterHoursEmergencyForwardPhoneNumber}
        label="Forward to (only 1 number)"
      />
      <SectionHeader {...page}> Manager Notifications </SectionHeader>
      <SwitchRow {...page} keyName={LocationVarKey.VoiceAfterHoursEmergencyHasSMS} label="Send SMS Alert" />
      <InputRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceAfterHoursEmergencyHasSMS, "1")}
        keyName={LocationVarKey.VoiceAfterHoursEmergencySMSPhoneNumbers}
        label="Phone Numbers (comma separated)"
      />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceAfterHoursEmergencyHasEmail} label="Send Email Alert" />
      <InputRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceAfterHoursEmergencyHasEmail, "1")}
        keyName={LocationVarKey.VoiceAfterHoursEmergencyEmails}
        label="Email Addresses (comma separated)"
      />
      <TextAreaRow
        {...page}
        marginTop
        label=" SMS & Email Content"
        hideIf={IF_ALL([
          IS_NOT_EQUAL(LocationVarKey.VoiceAfterHoursEmergencyHasEmail, "1"),
          IS_NOT_EQUAL(LocationVarKey.VoiceAfterHoursEmergencyHasSMS, "1")
        ])}
        keyName={LocationVarKey.VoiceAfterHoursEmergencyAlertContent}
      />
    </>
  );
}
